<div style="display:flex; gap:60px">
  <div style="width:30%">
    <rms-mod height="86vh">
      <div style="height:87vh">

        <!-- Suppliers -->
        <rms-table *ngIf="selectedView?.value === 1"
                   [HeaderButtons]="HeaderButtonsBound"
                   [data]="Suppliers"
                   [columns]="SupplierColumns"
                   [clickableRow]="true"
                   (onRowClick)="SelectVender($event)">
        </rms-table>

        <!-- Truckers -->
        <rms-table *ngIf="selectedView?.value === 2"
                   [HeaderButtons]="HeaderButtonsBound"
                   [data]="Truckers"
                   [columns]="TruckerColumns"
                   [clickableRow]="true"
                   (onRowClick)="SelectVender($event)">
        </rms-table>

        <!-- Warehouses -->
        <rms-table *ngIf="selectedView?.value === 3"
                   [HeaderButtons]="HeaderButtonsBound"
                   [data]="Warehouses"
                   [columns]="WarehouseColumns"
                   [clickableRow]="true"
                   (onRowClick)="SelectVender($event)">
        </rms-table>

        <!-- Supplier Requests -->
        <rms-table *ngIf="selectedView?.value === 4"
                   [HeaderButtons]="HeaderButtonsBound"
                   [data]="SupplierRequests"
                   [columns]="SupplierRequestColumns"
                   [clickableRow]="true"
                   (onRowClick)="SelectVender($event)">
        </rms-table>
      </div>
    </rms-mod>
  </div>
  @if(SelectedVender != null){
  <div style="width:65%">
    <rms-mod height="86vh" [flippable]="true" [flipped]="SelectedVender.ViewFiles">
      <div class="scale-wrapper" mod-front>
        <form #SupplierForm="ngForm" class="form-scroll-wrapper" *ngIf="selectedView.value == 1">
          <!--Sticky Header-->
          <div class="sticky-header">
            <div style="display:flex; justify-content:space-between; align-items:center">
              <div style="width:60%"><rms-input label="Supplier Name" [required]="true" name="SupplierName" [(ngModel)]="SelectedVender.SupplierName"></rms-input></div>
              <div> @if(SelectedVender.SupplierUpdated){<button class="btn-bg-green" mat-stroked-button (click)="UpdateSupplier()">Update</button>}</div>
              <div>
                <button mat-button class="btn-bg-green" (click)="SelectedVender.ViewFiles = !SelectedVender.ViewFiles">View Documents</button>
              </div>
              <div>
                <button mat-surface-button class="btn-bg-blue" (click)="sendSupplierFormEmail()">Send Supplier Form</button>
              </div>
            </div>
          </div>
          @if(!SelectedVender.SupplierID){
          <div class="form-scroll-body" *ngIf="SelectedVender">

            <div style="display:flex; gap:20px; justify-content:space-between; flex-wrap:wrap">

              <!-- LEFT COLUMN -->
              <div style="width:48%; min-width:420px; display:flex; flex-direction:column; gap:18px">
                <!-- CERTIFICATIONS -->
                <fieldset class="rms-fieldset form-flow">
                  <legend>Certifications</legend>

                  <div class="fields">
                    <rms-input label="FLOID" name="SupplierFLOID" [(ngModel)]="SelectedVender.SupplierFLOID"></rms-input>
                    <rms-input label="FDA Registration" name="SupplierFDA" [(ngModel)]="SelectedVender.SupplierFDA"></rms-input>
                    <rms-input label="FTUSAID" name="SupplierFTUSAID" [(ngModel)]="SelectedVender.SupplierFTUSAID"></rms-input>
                  </div>
                </fieldset>

                <!-- TRADER CONTACT -->
                <fieldset class="rms-fieldset form-flow">
                  <legend>Trader Contact</legend>

                  <!-- First Name -->
                  <div class="fields">
                    <rms-input label="First Name" name="TraderContactFirstName" [required]="true" [(ngModel)]="SelectedVender.TraderContactFirstName"></rms-input>
                    <rms-input label="Last Name" name="TraderContactLastName" [required]="true" [(ngModel)]="SelectedVender.TraderContactLastName"></rms-input>
                    <rms-input type="email" label="Email" name="SupplierEmail" [required]="true" [(ngModel)]="SelectedVender.SupplierEmail"></rms-input>
                    <rms-input label="Phone" name="SupplierTel" [(ngModel)]="SelectedVender.SupplierTel"></rms-input>
                    <rms-input label="Street" name="SupplierStreet" [(ngModel)]="SelectedVender.SupplierStreet"></rms-input>
                    <rms-input label="City" name="SupplierCity" [(ngModel)]="SelectedVender.SupplierCity"></rms-input>
                    <rms-input label="State" name="SupplierState" [(ngModel)]="SelectedVender.SupplierState"></rms-input>
                    <rms-input label="Postal Code" name="SupplierZip" [(ngModel)]="SelectedVender.SupplierZip"></rms-input>
                    <rms-input label="Country" name="SupplierContactCountry" [(ngModel)]="SelectedVender.SupplierContactCountry"></rms-input>
                    <rms-input label="Messenger" name="SupplierContactSkypeHandle" [(ngModel)]="SelectedVender.SupplierContactSkypeHandle"> </rms-input>
                  </div>
                </fieldset>
                <div>
                  <fieldset class="rms-fieldset" style="display:flex; flex-direction:column">
                    <legend>Coffees</legend>
                    <rms-select style="width:98%" label="Region" [options]="Regions" valueKey="RegionId" labelKey="RegionName" [(ngModel)]="SelectedVender.SupplierRegion" name="Region"></rms-select>
                    <rms-select style="width:98%" label="Country" [options]="Countries" valueKey="CountryID" labelKey="CountryName" [(ngModel)]="SelectedVender.SupplierCountry" name="Country"></rms-select>
                    <div style="width:98%; display:flex; justify-content:space-between">
                      <rms-textarea style="width:48%" label="Coffees" name="Coffees" [(ngModel)]="SelectedVender.TypesOfCoffee"></rms-textarea>
                      <rms-textarea style="width:48%" label="Notes" (onSave)="UpdateSupplier()" name="notes" [(ngModel)]="SelectedVender.Notes"></rms-textarea>
                    </div>

                  </fieldset>
                </div>
              </div>

              <!-- RIGHT COLUMN -->
              <div style="width:48%; min-width:420px; display:flex; flex-direction:column; gap:18px">

                <!-- TRAFFIC CONTACT -->
                <fieldset class="rms-fieldset form-flow">
                  <legend>Traffic Contact</legend>

                  <!-- First Name -->
                  <div class="fields">
                    <rms-input label="First Name" [required]="true" name="TrafficContactFirstName" [(ngModel)]="SelectedVender.TrafficContactFirstName"></rms-input>
                    <rms-input label="Last Name" [required]="true" name="TrafficContactLastName" [(ngModel)]="SelectedVender.TrafficContactLastName"></rms-input>
                    <rms-input type="email" label="Email" [required]="true" name="SupplierTrafficEmail" [(ngModel)]="SelectedVender.SupplierTrafficEmail"></rms-input>
                    <rms-input label="Phone" name="TrafficNo" [(ngModel)]="SelectedVender.TrafficNo"></rms-input>
                  </div>
                </fieldset>
                <!-- PRICE FIX CONTACT -->
                <fieldset class="rms-fieldset form-flow">
                  <legend>Price Fix Contact</legend>

                  <div class="fields">
                    <rms-input label="First Name" [required]="true" name="PriceFixFirstName" [(ngModel)]="SelectedVender.PriceFixFirstName"></rms-input>
                    <rms-input label="Last Name" [required]="true" name="PriceFixLastName" [(ngModel)]="SelectedVender.PriceFixLastName"></rms-input>
                    <rms-input type="email" label="Email" [required]="true" name="PriceFixEmail" [(ngModel)]="SelectedVender.PriceFixEmail"></rms-input>
                    <rms-input label="Phone" name="PriceFixPhone" [(ngModel)]="SelectedVender.PriceFixPhone"></rms-input>
                  </div>
                </fieldset>

                <!-- EMAILS -->
                <fieldset class="rms-fieldset">
                  <legend>Emails</legend>

                  <div style="display:flex; gap:20px; flex-wrap:wrap">

                    <!-- Approval/Rejection -->
                    <div style="width:48%; min-width:260px">
                      <strong style="display:block; margin-bottom:6px">Approval/Rejection</strong>
                      <rms-input [required]="true" type="email" label="Email 1" name="AppRejEmailNo1" [(ngModel)]="SelectedVender.AppRejEmailNo1"></rms-input>
                      <rms-input type="email" label="Email 2" name="AppRejEmailNo2" [(ngModel)]="SelectedVender.AppRejEmailNo2"></rms-input>
                      <rms-input type="email" label="Email 3" name="AppRejEmailNo3" [(ngModel)]="SelectedVender.AppRejEmailNo3"></rms-input>
                    </div>

                    <!-- Trader Secondary -->
                    <div style="width:48%; min-width:260px">
                      <strong style="display:block; margin-bottom:6px">Trader Secondary</strong>
                      <rms-input type="email" label="Email 1" name="TraderSecondaryEmail1" [(ngModel)]="SelectedVender.TraderSecondaryEmail1"></rms-input>
                      <rms-input type="email" label="Email 2" name="TraderSecondaryEmail2" [(ngModel)]="SelectedVender.TraderSecondaryEmail2"></rms-input>
                      <rms-input type="email" label="Email 3" name="TraderSecondaryEmail3" [(ngModel)]="SelectedVender.TraderSecondaryEmail3"></rms-input>
                    </div>

                    <!-- Traffic Secondary -->
                    <div style="width:48%; min-width:260px; margin-top:10px">
                      <strong style="display:block; margin-bottom:6px">Traffic Secondary</strong>
                      <rms-input type="email" label="Email 1" name="TrafficSecondaryEmail1" [(ngModel)]="SelectedVender.TrafficSecondaryEmail1"></rms-input>
                      <rms-input type="email" label="Email 2" name="TrafficSecondaryEmail2" [(ngModel)]="SelectedVender.TrafficSecondaryEmail2"></rms-input>
                      <rms-input type="email" label="Email 3" name="TrafficSecondaryEmail3" [(ngModel)]="SelectedVender.TrafficSecondaryEmail3"></rms-input>
                    </div>

                    <!-- Price Fix Secondary -->
                    <div style="width:48%; min-width:260px; margin-top:10px">
                      <strong style="display:block; margin-bottom:6px">Price Fix Secondary</strong>
                      <rms-input type="email" label="Email 1" name="PriceFixSecondaryEmail1" [(ngModel)]="SelectedVender.PriceFixSecondaryEmail1"></rms-input>
                      <rms-input type="email" label="Email 2" name="PriceFixSecondaryEmail2" [(ngModel)]="SelectedVender.PriceFixSecondaryEmail2"></rms-input>
                      <rms-input type="email" label="Email 3" name="PriceFixSecondaryEmail3" [(ngModel)]="SelectedVender.PriceFixSecondaryEmail3"></rms-input>
                    </div>

                  </div>
                </fieldset>
              </div>
            </div>
          </div>
          <button mat-stroked-button class="btn-bg-green" (click)="UpdateNames()" [disabled]="SupplierForm.invalid">Create Supplier</button>
          }
          @if(SelectedVender.SupplierID){
          <div class="form-scroll-body">
            <div style="display:flex; justify-content:space-between">
              <div style="width:45%">
                <contact-card (save)="UpdateTraderContact($event)" [contactData]="TraderContactFieldsBound" title="Trader Contact Information"></contact-card>
              </div>
              <div style="width:50%; display:flex; flex-direction:column; gap:30px">
                <contact-card (save)="UpdateTrafficContact($event)" [contactData]="TrafficeContactFieldsBound" [fields]="TrafficContactOptionsBound" title="Traffic Contact Information"></contact-card>
                <contact-card (save)="UpdatePriceFixContact($event)" [contactData]="PriceFixContactFieldsBound" [fields]="PriceFixContactOptionsBound" title="Price Fix Contact Information"></contact-card>
              </div>
            </div>
            <div style="display:flex; justify-content:space-between; gap:20px">
              @if(SelectedVender.SupplierID){
              <div style="width:100%; height:27vh; margin-top:10px">
                <rms-table [clickableRow]="true" (onRowClick)="UpdateSupplierEmail($event)" [HeaderButtons]="SupplierEmails.length < 3 ? SupplierHeaderButtons : []" [IncludePaginator]="false" [data]="SupplierEmails" [columns]="supplierEmailsColumns" [IncludeSearch]="false"></rms-table>
              </div>
              <div style="width:100%; height:27vh; margin-top:10px">
                <rms-table [clickableRow]="true" (onRowClick)="UpdateSupplierEmail($event)" [HeaderButtons]="TraderEmails.length < 3 ? SupplierTraderHeaderButtons : []" [IncludePaginator]="false" [data]="TraderEmails" [columns]="supplierTraderEmailsColumns" [IncludeSearch]="false"></rms-table>
              </div>
              <div style="width:100%; height:27vh; margin-top:10px">
                <rms-table [clickableRow]="true" (onRowClick)="UpdateSupplierEmail($event)" [HeaderButtons]="TrafficEmails.length < 3 ? SupplierTrafficHeaderButtons : []" [IncludePaginator]="false" [data]="TrafficEmails" [columns]="supplierTrafficEmailsColumns" [IncludeSearch]="false"></rms-table>
              </div>
              <div style="width:100%; height:27vh; margin-top:10px">
                <rms-table [clickableRow]="true" (onRowClick)="UpdateSupplierEmail($event)" [HeaderButtons]="PriceFixEmails.length < 3 ? SupplierPriceFixHeaderButtons : []" [IncludePaginator]="false" [data]="PriceFixEmails" [columns]="supplierPriceFixEmailsColumns" [IncludeSearch]="false"></rms-table>
              </div>
              }
            </div>

            <div style="display:flex; justify-content:space-between">
              <div style="width:40%">
                <fieldset class="rms-fieldset" style="display:flex; flex-direction:column">
                  <legend>Coffees</legend>
                  <rms-select style="width:98%" (ngModelChange)="SelectedVender.SupplierUpdated = true" label="Region" [options]="Regions" valueKey="RegionId" labelKey="RegionName" [(ngModel)]="SelectedVender.SupplierRegion" name="Region"></rms-select>
                  <rms-select style="width:98%" (ngModelChange)="SelectedVender.SupplierUpdated = true" label="Country" [options]="Countries" valueKey="CountryID" labelKey="CountryName" [(ngModel)]="SelectedVender.SupplierCountry" name="Country"></rms-select>
                  <div style="width:98%; display:flex; justify-content:space-between">
                    <rms-textarea style="width:48%" (ngModelChange)="SelectedVender.SupplierUpdated = true" label="Coffees" name="Coffees" [(ngModel)]="SelectedVender.TypesOfCoffee"></rms-textarea>
                    <rms-textarea style="width:48%" label="Notes" (onSave)="UpdateSupplier()" (ngModelChange)="SelectedVender.SupplierUpdated = true" name="notes" [(ngModel)]="SelectedVender.Notes"></rms-textarea>
                  </div>

                </fieldset>
              </div>
              <fieldset class="rms-fieldset" style="width:40%">
                <legend>Certifications</legend>
                <div class="fields">
                  <rms-input name="FLOID" label="FLOID" [(ngModel)]="SelectedVender.SupplierFLOID" (ngModelChange)="SelectedVender.SupplierUpdated = true"></rms-input>
                  <rms-input name="FDAREG" label="FDA Registration" [(ngModel)]="SelectedVender.SupplierFDA" (ngModelChange)="SelectedVender.SupplierUpdated = true"></rms-input>
                  <rms-input name="FTUSAID" label="FTUSAID" [(ngModel)]="SelectedVender.SupplierFTUSAID" (ngModelChange)="SelectedVender.SupplierUpdated = true"></rms-input>
                </div>
              </fieldset>
            </div>
          </div>
          }
        </form>
        <form #InventoryBasicForm="ngForm" class="form-flow" style="height:107vh" *ngIf="selectedView.value == 2">
          <div style="width: 98%"><rms-input name="company" label="Trucking Company Name" [(ngModel)]="SelectedVender.TruckerName"></rms-input></div>
          @if(!SelectedVender.TruckerID){
          <button mat-surface-button class="btn-bg-green" (click)="UpdateTrucker()">Create Trucker</button>
          }
          @if(SelectedVender.TruckerID){
          <div style="display:flex; justify-content:space-between">
            <div style="width:45%">
              <contact-card (save)="UpdateTruckerDispatchContact($event)" [contactData]="TruckerDispatchContactFieldsBound" [fields]="TruckerDispatchContactOptionsBound" title="Dispatch Contact Information"></contact-card>
              <div style="display:flex; gap:20px">
                <fieldset class="rms-fieldset">
                  <legend>Method To Get Rate</legend>
                  <div style="display: flex; flex-direction: column; gap: 15px;">
                    <rms-checkbox name="teleRate" [(ngModel)]="SelectedVender.RateContactTel" (ngModelChange)="SelectedVender.VenderUpdated = true" label="Telephone"></rms-checkbox>
                    <rms-checkbox name="onlineRate" [(ngModel)]="SelectedVender.RateWeb" (ngModelChange)="SelectedVender.VenderUpdated = true" label="Online"></rms-checkbox>
                  </div>
                </fieldset>
                <fieldset class="rms-fieldset">
                  <legend>Rates Based On</legend>
                  <div style="display: flex; flex-direction: column; gap: 15px;">
                    <rms-checkbox name="rateWeight" [(ngModel)]="SelectedVender.RateWeight" (ngModelChange)="SelectedVender.VenderUpdated = true" label="Weight"></rms-checkbox>
                    <rms-checkbox name="ratePallet" [(ngModel)]="SelectedVender.RatePerPallet" label="Pallet"></rms-checkbox>
                  </div>
                </fieldset>
              </div>
              <div>
                <rms-textarea label="Notes" name="notes" [(ngModel)]="SelectedVender.Notes" (ngModelChange)="SelectedVender.VenderUpdated = true"></rms-textarea>
              </div>
              <fieldset class="rms-fieldset">
                <legend>Account Information</legend>
                <div style="display: flex; flex-direction: column; gap: 15px;">
                  <rms-input type="percent" label="Discount" name="discount" [(ngModel)]="SelectedVender.DiscountRate" (ngModelChange)="SelectedVender.VenderUpdated = true"></rms-input>
                  <rms-input label="Account #" name="account" [(ngModel)]="SelectedVender.AccountNumber" (ngModelChange)="SelectedVender.VenderUpdated = true"></rms-input>
                </div>
              </fieldset>
              @if(SelectedVender.VenderUpdated){<button style="margin-top:5px" mat-surface-button class="btn-bg-green" (click)="UpdateTrucker()">Save</button>}
            </div>
            <div style="width:45%">
              <contact-card (save)="UpdateTruckerAccountContact($event)" [contactData]="TruckersAccountContactFieldsBound" [fields]="TruckerAccountContactOptionsBound" title="Account Contact Information"></contact-card>
              <fieldset class="rms-fieldset">
                <legend>Internet</legend>
                <div style="display:flex; flex-direction:column; gap: 15px;">
                  <rms-input label="Website" name="website" [(ngModel)]="SelectedVender.Website" (ngModelChange)="SelectedVender.VenderUpdated = true"></rms-input>
                  <rms-input label="Username" name="username" [(ngModel)]="SelectedVender.Username" (ngModelChange)="SelectedVender.VenderUpdated = true"></rms-input>
                  <rms-input label="Password" name="password" [(ngModel)]="SelectedVender.PasswordHash" (ngModelChange)="SelectedVender.VenderUpdated = true"></rms-input>
                </div>
              </fieldset>
            </div>
          </div>
          }
        </form>
        <form #InventoryBasicForm="ngForm" class="form-flow" style="height:107vh" *ngIf="selectedView.value == 3">
          <div style="width: 98%"><rms-input label="Warehouse Name" name="WarehouseName" [(ngModel)]="SelectedVender.LocationName"></rms-input></div>
          @if(!SelectedVender.LocationID){
          <button mat-surface-button class="btn-bg-green" (click)="UpdateWarehouse()">Create Warehouse</button>
          }
          @if(SelectedVender.LocationID){
          <div>
            <contact-card (save)="UpdateWarehouseContact($event)" [contactData]="WarehouseContactFieldsBound" [fields]="WarehouseContactOptionsBound" title="Dispatch Contact Information"></contact-card>
            <div style="width:80%; display:flex; gap: 15px">
              <div style="width:35%"><rms-textarea name="notes" label="Notes" [(ngModel)]="SelectedVender.LocationNotes" (ngModelChange)="SelectedVender.VenderUpdated = true"></rms-textarea></div>
              <div>
                <rms-select [options]="Cities" label="Destination" labelKey="destination_city" valueKey="destination_id" [(ngModel)]="SelectedVender.DestinationId" name="destination" (ngModelChange)="SelectedVender.VenderUpdated = true"></rms-select>
              </div>
              <div>
                <rms-input type="percent" name="rate" label="Monthly Storage Rate" [ngModel]="convertToPercent(SelectedVender.LocationMonthlyStorageRate)" (ngModelChange)="UpdateStorageRate($event)"></rms-input>
              </div>
            </div>
            @if(SelectedVender.VenderUpdated){<button mat-surface-button class="btn-bg-green" (click)="UpdateWarehouse()">Save</button>}
          </div>
          }
        </form>
        <div class="form-scroll-wrapper">
          <form #SupplierRequestForm="ngForm" class="form-scroll-wrapper" *ngIf="selectedView.value == 4">

            <!-- Sticky Header -->
            <div class="sticky-header">
              <div style="display:flex; justify-content:space-between; align-items:center; gap:12px">
                <div style="width:55%">

                  <!-- Supplier Name compare (UPDATE mode) -->
                  <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                       class="diff-line"
                       [class.changed]="isChanged(CurrentSupplierCompare.SupplierName, SelectedVender.SupplierName)">
                    <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierName) }}</span>
                    <span class="diff-arrow">→</span>
                    <span class="diff-new">{{ displayVal(SelectedVender.SupplierName) }}</span>
                  </div>

                  <rms-input label="Supplier Name"
                             name="SupplierName"
                             [(ngModel)]="SelectedVender.SupplierName">
                  </rms-input>
                </div>

                <div class="pill"
                     style="padding:6px 10px; border-radius:10px; font-weight:800"
                     [ngStyle]="{ background: RequestMode === 'update' ? '#fff1b8' : '#bae7ff' }">
                  {{ RequestMode === 'update' ? 'UPDATE' : 'NEW' }}
                </div>
                @if(RequestFiles){
                <div>
                  <button mat-button (click)="openRequestFile(RequestFiles[0])">View Organic Cert</button>
                </div>
                }
                <div style="display:flex; gap:10px; align-items:center">
                  <button mat-stroked-button class="btn-bg-green" type="button" (click)="runMergeSupplierFromRequest()">
                    Merge Supplier
                  </button>
                </div>
              </div>

              <div style="margin-top:6px; display:flex; gap:14px; flex-wrap:wrap; color:rgba(0,0,0,.65); font-size:12px">
                <div><strong>SupplierID:</strong> {{ SelectedVender.SupplierID || '— (new)' }}</div>
              </div>
            </div>

            <!-- Body -->
            <div class="form-scroll-body" *ngIf="SelectedVender">

              <div style="display:flex; gap:20px; justify-content:space-between; flex-wrap:wrap">

                <!-- LEFT COLUMN -->
                <div style="width:48%; min-width:420px; display:flex; flex-direction:column; gap:18px">

                  <!-- BASIC INFO -->
                  <fieldset class="rms-fieldset form-flow">
                    <legend>Basic Info</legend>

                    <div class="fields">

                      <!-- Country -->
                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.SupplierContactCountry, SelectedVender.SupplierContactCountry)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierContactCountry) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.SupplierContactCountry) }}</span>
                      </div>
                      <rms-input label="Country"
                                 name="SupplierContactCountry"
                                 [(ngModel)]="SelectedVender.SupplierContactCountry">
                      </rms-input>

                      <!-- Messenger -->
                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.SupplierContactSkypeHandle, SelectedVender.SupplierContactSkypeHandle)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierContactSkypeHandle) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.SupplierContactSkypeHandle) }}</span>
                      </div>
                      <rms-input label="Messenger"
                                 name="SupplierContactSkypeHandle"
                                 [(ngModel)]="SelectedVender.SupplierContactSkypeHandle">
                      </rms-input>

                    </div>
                  </fieldset>

                  <!-- CERTIFICATIONS -->
                  <fieldset class="rms-fieldset form-flow">
                    <legend>Certifications</legend>

                    <div class="fields">

                      <!-- FLOID -->
                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.SupplierFLOID, SelectedVender.SupplierFLOID)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierFLOID) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.SupplierFLOID) }}</span>
                      </div>
                      <rms-input label="FLOID"
                                 name="SupplierFLOID"
                                 [(ngModel)]="SelectedVender.SupplierFLOID">
                      </rms-input>

                      <!-- FDA -->
                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.SupplierFDA, SelectedVender.SupplierFDA)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierFDA) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.SupplierFDA) }}</span>
                      </div>
                      <rms-input label="FDA Registration"
                                 name="SupplierFDA"
                                 [(ngModel)]="SelectedVender.SupplierFDA">
                      </rms-input>

                      <!-- FTUSAID -->
                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.SupplierFTUSAID, SelectedVender.SupplierFTUSAID)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierFTUSAID) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.SupplierFTUSAID) }}</span>
                      </div>
                      <rms-input label="FTUSAID"
                                 name="SupplierFTUSAID"
                                 [(ngModel)]="SelectedVender.SupplierFTUSAID">
                      </rms-input>

                    </div>
                  </fieldset>

                  <!-- TRADER CONTACT -->
                  <fieldset class="rms-fieldset form-flow">
                    <legend>Trader Contact</legend>

                    <!-- First Name -->
                    <div class="fields">
                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.TraderContactFirstName, SelectedVender.TraderContactFirstName)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.TraderContactFirstName) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.TraderContactFirstName) }}</span>
                      </div>

                      <rms-input label="First Name"
                                 name="TraderContactFirstName"
                                 [(ngModel)]="SelectedVender.TraderContactFirstName">
                      </rms-input>

                    <!-- Last Name -->
                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.TraderContactLastName, SelectedVender.TraderContactLastName)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.TraderContactLastName) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.TraderContactLastName) }}</span>
                      </div>

                      <rms-input label="Last Name"
                                 name="TraderContactLastName"
                                 [(ngModel)]="SelectedVender.TraderContactLastName">
                      </rms-input>
                      <!-- Email -->
                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.SupplierEmail, SelectedVender.SupplierEmail)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierEmail) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.SupplierEmail) }}</span>
                        </div>
                        <rms-input label="Email" name="SupplierEmail" [(ngModel)]="SelectedVender.SupplierEmail"></rms-input>

                      <!-- Phone -->
                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.SupplierTel, SelectedVender.SupplierTel)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierTel) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.SupplierTel) }}</span>
                        </div>
                        <rms-input label="Phone" name="SupplierTel" [(ngModel)]="SelectedVender.SupplierTel"></rms-input>

                      <!-- Street -->
                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.SupplierStreet, SelectedVender.SupplierStreet)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierStreet) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.SupplierStreet) }}</span>
                        </div>
                        <rms-input label="Street" name="SupplierStreet" [(ngModel)]="SelectedVender.SupplierStreet"></rms-input>

                      <!-- City -->
                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.SupplierCity, SelectedVender.SupplierCity)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierCity) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.SupplierCity) }}</span>
                        </div>
                        <rms-input label="City" name="SupplierCity" [(ngModel)]="SelectedVender.SupplierCity"></rms-input>

                      <!-- State -->
                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.SupplierState, SelectedVender.SupplierState)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierState) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.SupplierState) }}</span>
                        </div>
                        <rms-input label="State" name="SupplierState" [(ngModel)]="SelectedVender.SupplierState"></rms-input>

                      <!-- Zip -->
                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.SupplierZip, SelectedVender.SupplierZip)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierZip) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.SupplierZip) }}</span>
                        </div>
                        <rms-input label="Postal Code" name="SupplierZip" [(ngModel)]="SelectedVender.SupplierZip"></rms-input>
                    </div>
                  </fieldset>
                </div>

                <!-- RIGHT COLUMN -->
                <div style="width:48%; min-width:420px; display:flex; flex-direction:column; gap:18px">

                  <!-- TRAFFIC CONTACT -->
                  <fieldset class="rms-fieldset form-flow">
                    <legend>Traffic Contact</legend>

                    <!-- First Name -->
                    <div class="fields">
                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.TrafficContactFirstName, SelectedVender.TrafficContactFirstName)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.TrafficContactFirstName) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.TrafficContactFirstName) }}</span>
                      </div>

                      <rms-input label="First Name"
                                 name="TrafficContactFirstName"
                                 [(ngModel)]="SelectedVender.TrafficContactFirstName">
                      </rms-input>

                    <!-- Last Name -->
                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.TrafficContactLastName, SelectedVender.TrafficContactLastName)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.TrafficContactLastName) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.TrafficContactLastName) }}</span>
                      </div>

                      <rms-input label="Last Name"
                                 name="TrafficContactLastName"
                                 [(ngModel)]="SelectedVender.TrafficContactLastName">
                      </rms-input>

                      <!-- Email -->
                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.SupplierTrafficEmail, SelectedVender.SupplierTrafficEmail)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.SupplierTrafficEmail) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.SupplierTrafficEmail) }}</span>
                        </div>
                        <rms-input label="Email" name="SupplierTrafficEmail" [(ngModel)]="SelectedVender.SupplierTrafficEmail"></rms-input>

                      <!-- Phone -->
                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.TrafficNo, SelectedVender.TrafficNo)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.TrafficNo) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.TrafficNo) }}</span>
                        </div>
                        <rms-input label="Phone" name="TrafficNo" [(ngModel)]="SelectedVender.TrafficNo"></rms-input>
                    </div>
                  </fieldset>
                  <!-- PRICE FIX CONTACT -->
                  <fieldset class="rms-fieldset form-flow">
                    <legend>Price Fix Contact</legend>

                    <div class="fields">

                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.PriceFixFirstName, SelectedVender.PriceFixFirstName)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.PriceFixFirstName) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.PriceFixFirstName) }}</span>
                      </div>
                      <rms-input label="First Name" name="PriceFixFirstName" [(ngModel)]="SelectedVender.PriceFixFirstName"></rms-input>

                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.PriceFixLastName, SelectedVender.PriceFixLastName)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.PriceFixLastName) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.PriceFixLastName) }}</span>
                      </div>
                      <rms-input label="Last Name" name="PriceFixLastName" [(ngModel)]="SelectedVender.PriceFixLastName"></rms-input>

                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.PriceFixEmail, SelectedVender.PriceFixEmail)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.PriceFixEmail) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.PriceFixEmail) }}</span>
                      </div>
                      <rms-input label="Email" name="PriceFixEmail" [(ngModel)]="SelectedVender.PriceFixEmail"></rms-input>

                      <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                           class="diff-line"
                           [class.changed]="isChanged(CurrentSupplierCompare.PriceFixPhone, SelectedVender.PriceFixPhone)">
                        <span class="diff-old">{{ displayVal(CurrentSupplierCompare.PriceFixPhone) }}</span>
                        <span class="diff-arrow">→</span>
                        <span class="diff-new">{{ displayVal(SelectedVender.PriceFixPhone) }}</span>
                      </div>
                      <rms-input label="Phone" name="PriceFixPhone" [(ngModel)]="SelectedVender.PriceFixPhone"></rms-input>

                    </div>
                  </fieldset>

                  <!-- EMAILS -->
                  <fieldset class="rms-fieldset">
                    <legend>Emails</legend>

                    <div style="display:flex; gap:20px; flex-wrap:wrap">

                      <!-- Approval/Rejection -->
                      <div style="width:48%; min-width:260px">
                        <strong style="display:block; margin-bottom:6px">Approval/Rejection</strong>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.AppRejEmailNo1, SelectedVender.AppRejEmailNo1)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.AppRejEmailNo1) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.AppRejEmailNo1) }}</span>
                        </div>
                        <rms-input label="Email 1" name="AppRejEmailNo1" [(ngModel)]="SelectedVender.AppRejEmailNo1"></rms-input>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.AppRejEmailNo2, SelectedVender.AppRejEmailNo2)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.AppRejEmailNo2) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.AppRejEmailNo2) }}</span>
                        </div>
                        <rms-input label="Email 2" name="AppRejEmailNo2" [(ngModel)]="SelectedVender.AppRejEmailNo2"></rms-input>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.AppRejEmailNo3, SelectedVender.AppRejEmailNo3)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.AppRejEmailNo3) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.AppRejEmailNo3) }}</span>
                        </div>
                        <rms-input label="Email 3" name="AppRejEmailNo3" [(ngModel)]="SelectedVender.AppRejEmailNo3"></rms-input>
                      </div>

                      <!-- Trader Secondary -->
                      <div style="width:48%; min-width:260px">
                        <strong style="display:block; margin-bottom:6px">Trader Secondary</strong>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.TraderSecondaryEmail1, SelectedVender.TraderSecondaryEmail1)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.TraderSecondaryEmail1) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.TraderSecondaryEmail1) }}</span>
                        </div>
                        <rms-input label="Email 1" name="TraderSecondaryEmail1" [(ngModel)]="SelectedVender.TraderSecondaryEmail1"></rms-input>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.TraderSecondaryEmail2, SelectedVender.TraderSecondaryEmail2)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.TraderSecondaryEmail2) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.TraderSecondaryEmail2) }}</span>
                        </div>
                        <rms-input label="Email 2" name="TraderSecondaryEmail2" [(ngModel)]="SelectedVender.TraderSecondaryEmail2"></rms-input>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.TraderSecondaryEmail3, SelectedVender.TraderSecondaryEmail3)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.TraderSecondaryEmail3) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.TraderSecondaryEmail3) }}</span>
                        </div>
                        <rms-input label="Email 3" name="TraderSecondaryEmail3" [(ngModel)]="SelectedVender.TraderSecondaryEmail3"></rms-input>
                      </div>

                      <!-- Traffic Secondary -->
                      <div style="width:48%; min-width:260px; margin-top:10px">
                        <strong style="display:block; margin-bottom:6px">Traffic Secondary</strong>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.TrafficSecondaryEmail1, SelectedVender.TrafficSecondaryEmail1)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.TrafficSecondaryEmail1) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.TrafficSecondaryEmail1) }}</span>
                        </div>
                        <rms-input label="Email 1" name="TrafficSecondaryEmail1" [(ngModel)]="SelectedVender.TrafficSecondaryEmail1"></rms-input>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.TrafficSecondaryEmail2, SelectedVender.TrafficSecondaryEmail2)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.TrafficSecondaryEmail2) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.TrafficSecondaryEmail2) }}</span>
                        </div>
                        <rms-input label="Email 2" name="TrafficSecondaryEmail2" [(ngModel)]="SelectedVender.TrafficSecondaryEmail2"></rms-input>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.TrafficSecondaryEmail3, SelectedVender.TrafficSecondaryEmail3)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.TrafficSecondaryEmail3) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.TrafficSecondaryEmail3) }}</span>
                        </div>
                        <rms-input label="Email 3" name="TrafficSecondaryEmail3" [(ngModel)]="SelectedVender.TrafficSecondaryEmail3"></rms-input>
                      </div>

                      <!-- Price Fix Secondary -->
                      <div style="width:48%; min-width:260px; margin-top:10px">
                        <strong style="display:block; margin-bottom:6px">Price Fix Secondary</strong>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.PriceFixSecondaryEmail1, SelectedVender.PriceFixSecondaryEmail1)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.PriceFixSecondaryEmail1) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.PriceFixSecondaryEmail1) }}</span>
                        </div>
                        <rms-input label="Email 1" name="PriceFixSecondaryEmail1" [(ngModel)]="SelectedVender.PriceFixSecondaryEmail1"></rms-input>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.PriceFixSecondaryEmail2, SelectedVender.PriceFixSecondaryEmail2)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.PriceFixSecondaryEmail2) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.PriceFixSecondaryEmail2) }}</span>
                        </div>
                        <rms-input label="Email 2" name="PriceFixSecondaryEmail2" [(ngModel)]="SelectedVender.PriceFixSecondaryEmail2"></rms-input>

                        <div *ngIf="RequestMode === 'update' && CurrentSupplierCompare"
                             class="diff-line"
                             [class.changed]="isChanged(CurrentSupplierCompare.PriceFixSecondaryEmail3, SelectedVender.PriceFixSecondaryEmail3)">
                          <span class="diff-old">{{ displayVal(CurrentSupplierCompare.PriceFixSecondaryEmail3) }}</span>
                          <span class="diff-arrow">→</span>
                          <span class="diff-new">{{ displayVal(SelectedVender.PriceFixSecondaryEmail3) }}</span>
                        </div>
                        <rms-input label="Email 3" name="PriceFixSecondaryEmail3" [(ngModel)]="SelectedVender.PriceFixSecondaryEmail3"></rms-input>
                      </div>

                    </div>
                  </fieldset>

                </div>
              </div>

              <!-- Merge Preview -->
              <fieldset class="rms-fieldset" style="margin-top:18px" *ngIf="RequestMergePreviewJson">
                <legend>Merge Supplier Payload (Preview)</legend>
                <rms-textarea label="Payload JSON"
                              name="MergePreview"
                              [ngModel]="RequestMergePreviewJson">
                </rms-textarea>
              </fieldset>

            </div>
          </form>
        </div>
      </div>
      <div mod-back>
        <div class="scale-wrapper">
          <div class="sticky-header">
            <div style="display:flex; justify-content:space-between; align-items:center">
              <div style="width:60%"><rms-input label="Supplier Name" [required]="true" name="SupplierName" [(ngModel)]="SelectedVender.SupplierName"></rms-input></div>
              <div>
                <button mat-button class="btn-bg-green" (click)="SelectedVender.ViewFiles = !SelectedVender.ViewFiles">View Details</button>
              </div>
              <div>
                <button mat-surface-button class="btn-bg-blue" (click)="sendSupplierFormEmail()">Send Supplier Form</button>
              </div>
            </div>
          </div>
          <rms-file-explorer height="65vh" [rootPath]="supplierFolderRootPath" (Uploaded)="UploadDocument($event)"></rms-file-explorer>
        </div>
      </div>
    </rms-mod>
  </div>
  }
</div>
